export default __webpack_public_path__ + "static/media/Resources.9a7a3813.svg";